"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = refreshDirectLineToken;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _fetchJSON = _interopRequireDefault(require("./fetchJSON"));

// Refreshes the given token
function refreshDirectLineToken(_x) {
  return _refreshDirectLineToken.apply(this, arguments);
}

function _refreshDirectLineToken() {
  _refreshDirectLineToken = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(token) {
    var _yield$fetchJSON, refreshedToken;

    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return (0, _fetchJSON.default)('https://directline.botframework.com/v3/directline/tokens/refresh', {
              headers: {
                authorization: "Bearer ".concat(token)
              },
              method: 'POST'
            });

          case 2:
            _yield$fetchJSON = _context.sent;
            refreshedToken = _yield$fetchJSON.token;
            return _context.abrupt("return", refreshedToken);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _refreshDirectLineToken.apply(this, arguments);
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJyZWZyZXNoRGlyZWN0TGluZVRva2VuIiwidG9rZW4iLCJmZXRjaEpTT04iLCJoZWFkZXJzIiwiYXV0aG9yaXphdGlvbiIsIm1ldGhvZCIsInJlZnJlc2hlZFRva2VuIl0sInNvdXJjZVJvb3QiOiJkaXJlY3RsaW5lc3BlZWNoOi8vLyIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3V0aWxzL3JlZnJlc2hEaXJlY3RMaW5lVG9rZW4uanMiXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IGZldGNoSlNPTiBmcm9tICcuL2ZldGNoSlNPTic7XG5cbi8vIFJlZnJlc2hlcyB0aGUgZ2l2ZW4gdG9rZW5cbmV4cG9ydCBkZWZhdWx0IGFzeW5jIGZ1bmN0aW9uIHJlZnJlc2hEaXJlY3RMaW5lVG9rZW4odG9rZW4pIHtcbiAgY29uc3QgeyB0b2tlbjogcmVmcmVzaGVkVG9rZW4gfSA9IGF3YWl0IGZldGNoSlNPTihcbiAgICAnaHR0cHM6Ly9kaXJlY3RsaW5lLmJvdGZyYW1ld29yay5jb20vdjMvZGlyZWN0bGluZS90b2tlbnMvcmVmcmVzaCcsXG4gICAge1xuICAgICAgaGVhZGVyczoge1xuICAgICAgICBhdXRob3JpemF0aW9uOiBgQmVhcmVyICR7dG9rZW59YFxuICAgICAgfSxcbiAgICAgIG1ldGhvZDogJ1BPU1QnXG4gICAgfVxuICApO1xuXG4gIHJldHVybiByZWZyZXNoZWRUb2tlbjtcbn1cbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7OztBQUFBOztBQUVBO1NBQzhCQSxzQjs7Ozs7b0dBQWYsaUJBQXNDQyxLQUF0QztJQUFBOztJQUFBO01BQUE7UUFBQTtVQUFBO1lBQUE7WUFBQSxPQUMyQixJQUFBQyxrQkFBQSxFQUN0QyxrRUFEc0MsRUFFdEM7Y0FDRUMsT0FBTyxFQUFFO2dCQUNQQyxhQUFhLG1CQUFZSCxLQUFaO2NBRE4sQ0FEWDtjQUlFSSxNQUFNLEVBQUU7WUFKVixDQUZzQyxDQUQzQjs7VUFBQTtZQUFBO1lBQ0VDLGNBREYsb0JBQ0xMLEtBREs7WUFBQSxpQ0FXTkssY0FYTTs7VUFBQTtVQUFBO1lBQUE7UUFBQTtNQUFBO0lBQUE7RUFBQSxDIn0=